export default __webpack_public_path__ + "static/media/lever.d511f564.svg";